<template>
  <div id="order-products">
    <h2 class="mt-8 mb-4">Éléments de la commande</h2>
      <v-row dense>
        <v-card v-for="(item, i) in order.line_items" :key="item.id" :dark="true" color="#00585f" width="100%" class="mb-4">
          <v-card-title>
            <v-icon v-if="!isBadgeProduct(item.product_id)">mdi-ticket-outline</v-icon>
            <v-icon v-if="isBadgeProduct(item.product_id)">mdi-shield-star-outline</v-icon>
            {{ item.name }}
          </v-card-title>
          <v-card-text class="b-separator">
            <ul class="resume-tech">
              <li v-if="isBadgeProduct(item.product_id)">Quantité: {{ item.quantity }}</li>
              <li v-if="!isBadgeProduct(item.product_id)">
                {{ item.total }} {{ order.currency_symbol }}
              </li>
              <li v-if="!isBadgeProduct(item.product_id)">
                {{ bookings[i].start | formatDate }}
              </li>
              <li v-if="!isBadgeProduct(item.product_id)">
                Langue: {{ retrieveResource(bookings[i].resource_id) }}
              </li>
            </ul>
          </v-card-text>
          <v-card-text v-if="!isBadgeProduct(item.product_id)">
            <ul class="resume-tech tech-bix">
              <li v-for="(quantity, person) in bookings[i].person_counts" :key="person">
                {{ retrievePersonText(person) }}: {{ quantity }}
              </li>
            </ul>
          </v-card-text>
        </v-card>
        <v-card v-for="item in order.fee_lines" :key="item.id" :dark="true" color="#00585f" width="100%" class="mb-4">
          <v-card-title>
            <v-icon >mdi-shield-star-outline</v-icon>
            {{ item.name }}
          </v-card-title>
          <v-card-text class="b-separator">
            <ul class="resume-tech">
              <li>Quantité: {{ item.amount }}</li>
            </ul>
          </v-card-text>
        </v-card>
      </v-row>
  </div>
</template>

<script>
export default {
  props: ['order', 'bookings'],
  computed: {
    getPersons (i) {
      let arr = []
      for (let attribute in this.bookings[i].person_counts) {
        arr.push(attribute)
      }
      return arr
    }
  },
  filters: {
    formatDate (value) {
      return new Date(value * 1000).toLocaleString().split(' ')[0]
    }
  },
  methods: {
    retrievePersonText (value) {
      let personTexts = this.$store.getters.getBookablePersons
      return personTexts[value]
    },
    retrieveResource (value) {
      let resources = this.$store.getters.getResources
      return resources[value]
    },
    isBadgeProduct (value) {
      return [29019, 29294, 29295].includes(value)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
